import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n";
import { PROJECTS } from "@/data/projects";
import { Reveal } from "@/components/Reveal";

export default function ProjectsGrid() {
  const { lang, t } = useLanguage();

  return (
    <section id="ventures" className="bg-bone py-24 md:py-32" data-testid="ventures-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="mb-16 md:mb-24 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">{t.ventures.overline}</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-ebony" data-testid="ventures-title">
            {t.ventures.title}
          </h2>
          <p className="mt-4 text-sm md:text-base font-light text-ebony/60">{t.ventures.sub}</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.slug} delay={0.05 * (i % 3)} className={`${p.span}`}>
              <Link
                to={`/${lang}/ventures/${p.slug}`}
                data-testid={`venture-card-${p.slug}`}
                className={`group relative block overflow-hidden rounded-md border border-ebony/10 ${p.height}`}
              >
                <img
                  src={p.image}
                  alt={p.name}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-ebony/45 transition-colors duration-700 group-hover:bg-ebony/30" />
                <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-12">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-ochre mb-2">{p.index}</span>
                  <div className="flex items-end justify-between gap-4">
                    <div>
                      <h3 className="font-serif text-3xl md:text-4xl font-light tracking-tight text-bone">{p.name}</h3>
                      <p className="mt-1 text-sm font-light text-bone/70">{p[lang].tagline}</p>
                    </div>
                    <span className="shrink-0 flex h-11 w-11 items-center justify-center rounded-full border border-bone/40 text-bone transition-colors duration-500 group-hover:bg-terracotta group-hover:border-terracotta">
                      <ArrowUpRight size={18} className="transition-transform duration-500 group-hover:rotate-45" />
                    </span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
